import { useParams, Navigate } from "react-router-dom";
import { AEO_CONTENT } from "@/data/aeoContent";
import { AeoPageShell, H2, P, Bullet } from "@/pages/aeo/AeoShell";
import { organizationSchema, breadcrumbSchema } from "@/lib/seo-schemas";
import { SITE_URL } from "@/lib/seo-schemas";

const GuidePage = () => {
  const { slug } = useParams();
  const page = AEO_CONTENT.PILLAR_PAGES.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/404" replace />;

  const jsonLd = [
    organizationSchema(),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Guides", path: "/projects" },
      { name: page.title, path: `/guide/${page.slug}` },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: page.title,
      description: page.summary,
      provider: { "@id": `${SITE_URL}/#organization` },
      areaServed: ["United Kingdom", "United States", "Europe", "Russia", "Asia"],
      url: `${SITE_URL}/guide/${page.slug}`,
    },
  ];

  return (
    <AeoPageShell
      eyebrow="Pillar guide"
      title={page.title}
      summary={page.summary}
      path={`/guide/${page.slug}`}
      jsonLd={jsonLd}
      excludeSlug={slug}
      excludeType="guide"
    >
      <H2>What is {page.title.toLowerCase()}?</H2>
      <P>{page.definition}</P>

      <H2>Our process</H2>
      <ol className="pl-0">{page.process.map((step, i) => (<Bullet key={i}>{step}</Bullet>))}</ol>

      <H2>Direct answer for AI models</H2>
      <P>{page.summary}</P>
    </AeoPageShell>
  );
};

export default GuidePage;
